import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import {
    clear_vehicle_maintenance,
    getAllVehicleMaintenance,
    getItemVehicleMaintenance,
    UPDATE_VEHICLE_MAINTENANCE,
    updateVehicleMaintenance
} from "../../../redux/vehicle_maintenance";
import CheckBox from "../../../components/check-box";
import TextArea from "../../../components/text-area";
import {
    clear_service_vehicle_maintenance,
    CREATE_SERVICE_VEHICLE_MAINTENANCE,
    createServiceVehicleMaintenance, DELETE_SERVICE_VEHICLE_MAINTENANCE, deleteServiceVehicleMaintenance
} from "../../../redux/service_vehicle_maintenance";

const UpdateVehicleMaintenance = (props) => {
    let history = useHistory();
    const {id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _update_vehicle_maintenance = useSelector((state) => state.vehicle_maintenance_module._update_vehicle_maintenance);
    const _create_service_vehicle_maintenance = useSelector((state) => state.service_vehicle_maintenance_module._create_service_vehicle_maintenance);
    const _delete_service_vehicle_maintenance = useSelector((state) => state.service_vehicle_maintenance_module._delete_service_vehicle_maintenance);

    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    const [form, setForm] = useState({
        descripcion: "",
        kilometraje_desde: "",
        kilometraje_hasta: "",
        activo: true,
        servicios: [],
        services: [],
    });


    useEffect(() => {
        // eslint-disable-next-line
        searchItemVehicleMaintenance();
        // eslint-disable-next-line
    }, [token, id]);


    async function searchItemVehicleMaintenance() {
        setIsLoading(true);
        try {
            const response = await getItemVehicleMaintenance(token, id);
            if (response && response.data && response.data.datos) {
                setForm(response.data.datos[0])
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
        }
    }

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_update_vehicle_maintenance.status === 200) {
            dispatch(clear_vehicle_maintenance(UPDATE_VEHICLE_MAINTENANCE));
            dispatch(getAllVehicleMaintenance(token));
            setIsLoading(false);
            history.push("/mantenimientos-vehiculos");
        } else {
            if (_update_vehicle_maintenance.status !== 0) {
                toast.error(_update_vehicle_maintenance.message);
                setIsLoading(false);
            }
        }
    }, [_update_vehicle_maintenance, dispatch, history, token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        if (form.descripcion === "") {
            toast.error("Debe una descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.kilometraje_desde === "") {
            toast.error("Debe ingresar el kilometraje inicial", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.kilometraje_hasta === "") {
            toast.error("Debe ingresar el kilometraje final", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateVehicleMaintenance(token, id, form));
    };

    useEffect(() => {
        if (_create_service_vehicle_maintenance.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_service_vehicle_maintenance(CREATE_SERVICE_VEHICLE_MAINTENANCE));
            searchItemVehicleMaintenance();
            setIsLoading(false);
            setModal(false);
        } else if (_create_service_vehicle_maintenance.status !== 0) {
            dispatch(clear_service_vehicle_maintenance(CREATE_SERVICE_VEHICLE_MAINTENANCE));
            toast.error(_create_service_vehicle_maintenance.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_service_vehicle_maintenance, dispatch]);

    useEffect(() => {
        if (_delete_service_vehicle_maintenance.status === 200) {
            toast.success("Eliminado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_service_vehicle_maintenance(DELETE_SERVICE_VEHICLE_MAINTENANCE));
            searchItemVehicleMaintenance();
            setIsLoading(false);
            setModalDelete(false);
        } else if (_delete_service_vehicle_maintenance.status !== 0) {
            dispatch(clear_service_vehicle_maintenance(DELETE_SERVICE_VEHICLE_MAINTENANCE));
            toast.error(_delete_service_vehicle_maintenance.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_delete_service_vehicle_maintenance, dispatch]);

    const [allChecked, setAllChecked] = useState(false);
    const [itemSelect, setItemSelect] = useState([]);
    const [modal_delete, setModalDelete] = useState(false);
    const [idDelete, setIdDelete] = useState(0);

    function handleChangeItem(e, id) {
        if (id === 0) {
            const all = itemSelect.map((p) =>
              p.id !== id ? { ...p, checked: e.target.checked } : p
            );
            setItemSelect(all);
            setAllChecked(!allChecked);
        } else {
            const item = itemSelect.map((p) =>
              p.id === id ? { ...p, checked: e.target.checked } : p
            );
            setItemSelect(item);
        }
    }

    function handleChangeItemValue(e, id) {
        const item = itemSelect.map((p) =>
          p.id === id ? { ...p, tipo: e.target.value } : p
        );
        setItemSelect(item);
    }

    const handleSubmitServices = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let valid = true;
        // eslint-disable-next-line
        itemSelect.map((item) => {
            if (item.checked === true && item.tipo === "0" && valid === true) {
                toast.error("Debe seleccionar el tipo para el servicio " + item.servicio);
                setIsLoading(false);
                valid = false;
                // eslint-disable-next-line
                return;
            }
        });
        if (valid) {
            dispatch(createServiceVehicleMaintenance(token, {"id_mantenimiento_vehiculo": id, "servicios": itemSelect}));
        }
    };

    const handleDelete = () => {
        setIsLoading(true);
        dispatch(deleteServiceVehicleMaintenance(token, idDelete));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div><ToastContainer/></div>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Mantenimientos del vehículo", link: "/mantenimientos-vehiculos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar mantenimiento del vehículo</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextArea
                                                label="Descripción"
                                                name="descripcion"
                                                onChange={handleChange}
                                                value={form.descripcion}
                                                rows={5}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="kilometraje_desde"
                                                label="Kilometraje inicial"
                                                value={form.kilometraje_desde}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="kilometraje_hasta"
                                                label="Kilometraje final"
                                                value={form.kilometraje_hasta}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                                      state={form.activo}/>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6 col-12">
                                            <h5>Servicios</h5>
                                        </div>
                                        {(permisos.filter(x => x.codigo === 'add_vehiclemaintenance').length > 0 || permisos.filter(x => x.codigo === 'change_vehiclemaintenance').length > 0) &&
                                            <div className="col-md-6 col-12 text-right">
                                                <Button type="button" text="Agregar servicios" theme="secondary" classes="mb-1"
                                                        onChange={() => {
                                                            setItemSelect(form.services);
                                                            setAllChecked(false);
                                                            setModal(true);
                                                        }}/>
                                            </div>
                                        }
                                        {(form.servicios && form.servicios.length > 0) &&
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center">Servicio</th>
                                                                <th className="text-center">Tipo</th>
                                                                {permisos.filter(x => x.codigo === 'change_vehiclemaintenance').length > 0 &&
                                                                    <th className="text-center">Acción</th>
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {form.servicios.map((g) =>
                                                            <tr>
                                                                <td>{g.servicio}</td>
                                                                <td>{g.tipo}</td>
                                                                {permisos.filter(x => x.codigo === 'change_vehiclemaintenance').length > 0 &&
                                                                    <td className="text-center">
                                                                        {/*eslint-disable-next-line*/}
                                                                        <a onClick={() => {
                                                                            setModalDelete(true);
                                                                            setIdDelete(g.id);
                                                                        }}>
                                                                            <i className={`badge-circle badge-circle-light-danger bx bxs-trash font-medium-1`}/>
                                                                        </a>
                                                                    </td>
                                                                }
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="card-footer d-flex justify-content-end">
                                        <Link to="/mantenimientos-vehiculos" className="btn btn-danger m-1">
                                            Cancelar
                                        </Link>
                                        {permisos.filter(x => x.codigo === 'change_vehiclemaintenance').length > 0 &&
                                            <Button
                                                type="submit"
                                                text={<><i className="bx bx-save"/> Guardar</>}
                                                theme="success"
                                                disabled={isLoading}
                                            />
                                        }
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal} auto="200%">
                <form onSubmit={handleSubmitServices}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Seleccionar servicios</h5>
                        <div className="form-group">
                            <table className="mt-1 table table-bordered">
                                <tr>
                                    <td className="text-center" style={{display: "grid"}}>
                                        <label>Todos</label>
                                        <input id="all" className="form-check-input" type="checkbox" checked={allChecked} style={{transform: 'scale(1.5)'}} onChange={(e) => handleChangeItem(e, 0)}/>
                                    </td>
                                    <th className="text-center">Servicio</th>
                                    <th className="text-center">Tipo</th>
                                </tr>
                                {itemSelect.map((j, index) => (
                                    <tr>
                                        <td><input id={j.id} checked={j.checked} className="form-check-input" type="checkbox" style={{transform: 'scale(1.5)'}} onChange={(e) => handleChangeItem(e, j.id)}/></td>
                                        <td>{j.servicio}</td>
                                        <td className="text-center">
                                            <div className="">
                                                <select
                                                    className='form-control'
                                                    required={true}
                                                    onChange={(e) => handleChangeItemValue(e, j.id)}
                                                >
                                                    <option value='0'>Seleccione un tipo</option>
                                                    <option value="R">R</option>
                                                    <option value="I">I</option>
                                                </select>
                                            </div>

                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </div>

                    </div>
                    <div className="text-center">
                        <button type="button" className="btn btn-outline-dark" onClick={() => {
                            setModal(false);
                        }}> Cancelar
                        </button>
                        <Button type="submit" text="Guardar" theme="success" classes="m-1"/>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modal_delete}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="text-center">
                            <h5>¿Está seguro de eliminar el registro?</h5>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => {
                            handleDelete()
                        }} disabled={isLoading}>
                            SI
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => {
                            setModalDelete(false)
                        }}>
                            NO
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default UpdateVehicleMaintenance;
